import React, { useEffect, useState } from "react";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/flatpickr.min.css";
import { toast } from "react-toastify";
import { decryptToken } from "../utils/getToken";

const TaskModalEdit = ({ isOpen, setIsOpen, leadOptions, assignOptions, taskEdit, fetchTask }) => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const [dueDate, setDueDate] = useState();
    const [startDate, setStartDate] = useState();
    const [repetition, setRepetition] = useState(null);
    const [startTime, setStartTime] = useState();
    const [customDate, setCustomDate] = useState(null);
    const [title, setTitle] = useState("");
    const [priority, setPriority] = useState(null);
    const [assignTo, setAssignTo] = useState(null);
    const [list, setList] = useState(null);
    const [notes, setNotes] = useState("");
    const [file, setFile] = useState(null);
    const url = process.env.REACT_APP_LINK;
    const token = decryptToken("accessToken") || "";

    const repetitionOptions = [
        { value: "none", label: "Does not repeat" },
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
        { value: "monthly", label: "Monthly" },
        { value: "annually", label: "Annually" },
        { value: "custom", label: "Custom" },
    ];

    const priorityOptions = [
        { value: "high", label: "High" },
        { value: "medium", label: "Medium" },
        { value: "low", label: "Low" },
    ];

    const capitalize = (str) => {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    // console.log(taskEdit.customDate)
    // Fetch employees


    useEffect(() => {
        if (taskEdit) {
            const safeParseDate = (dateStr) => {
                if (!dateStr || dateStr === "0000-00-00") return null;
                // Fix non-ISO format: replace " " with "T"
                const isoString = dateStr.includes("T") ? dateStr : dateStr.replace(" ", "T");
                const parsed = new Date(isoString);
                return isNaN(parsed) ? null : parsed;
            };
            setTitle(taskEdit.title || "");
            // setDueDate(taskEdit.due_date ? new Date(taskEdit.due_date) : new Date());
            // setStartDate(taskEdit.start_date ? new Date(taskEdit.start_date) : null);
            setPriority(taskEdit.priority ? { value: taskEdit.priority, label: capitalize(taskEdit.priority) } : null);
            setRepetition(taskEdit.repetition ? { value: taskEdit.repetition, label: capitalize(taskEdit.repetition) } : null);
            // setCustomDate(taskEdit?.customDate ? new Date(`${taskEdit?.customDate}T00:00:00`) : null);
            setDueDate(safeParseDate(taskEdit.due_date) || new Date());
            setStartDate(safeParseDate(taskEdit.start_date) || new Date());
            setCustomDate(safeParseDate(taskEdit.customDate));
            setStartTime(taskEdit.start_time || "")
            // Map assign_to to { value, label } using assignOptions
            const assignedUser = assignOptions.find(u => u.value === parseInt(taskEdit.assign_to));
            setAssignTo(assignedUser || null);

            // Map list_id to { value, label } using leadOptions
            const listObj = leadOptions.find(l => l.value === taskEdit.list_id);
            setList(listObj || null);

            setNotes(taskEdit.notes || "");
            setFile(null);
        }
    }, [taskEdit, assignOptions, leadOptions]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formData = new FormData();
            formData.append("title", title);
            formData.append("due_date", dueDate);
            formData.append("priority", priority?.value || "");
            formData.append("repetition", repetition?.value || "");
            if (repetition?.value === "custom") {
                formData.append("customDate", customDate);
            }
            formData.append("assign_to", assignTo?.value || "");
            formData.append("list_id", list?.value || "");
            formData.append("notes", notes);
            formData.append("start_time", startTime);
            formData.append("start_date", startDate);
            if (file) {
                formData.append("attachment", file);
            }

            const response = await fetch(`${url}/task/${taskEdit.id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            const res = await response.json();
            if (response.ok) {
                toast.success("Task updated successfully!");
                setIsOpen(false);
            } else {
                toast.error(res.error || "Failed to create task");
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    if (!isOpen) return null;
    return (
        <div
            className="fixed inset-0 bg-black/40 flex justify-center items-end z-[100000]"
            onClick={() => setIsOpen(false)}
        >
            <div
                className="bg-white rounded-t-2xl shadow-2xl w-full max-w-2xl p-6 relative max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <h2 className="text-2xl font-semibold text-blue-600 mb-6 text-center">
                    Create New Task
                </h2>

                <form className="space-y-5" onSubmit={handleSubmit}>
                    {/* Title */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Title
                        </label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter task title"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* 2-column layout */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {/* Due Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Start Date
                            </label>
                            <Flatpickr
                                value={startDate}
                                // options={{ minDate: "today" }}
                                onChange={(date) => setStartDate(date[0])}
                                placeholder="Select Date"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Due Date
                            </label>
                            <Flatpickr
                                value={dueDate}
                                // options={{ minDate: "today" }}
                                onChange={(date) => setDueDate(date[0])}
                                placeholder="Select Date"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Repetition
                            </label>
                            <Select
                                options={repetitionOptions}
                                value={repetition}
                                onChange={setRepetition}
                                placeholder="Select repetition"
                            />
                            {repetition?.value === "custom" && (
                                <Flatpickr
                                    value={customDate}
                                    // options={{ minDate: "today" }}
                                    onChange={(date) => setCustomDate(date[0])}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Pick custom date"
                                />
                            )}

                            {repetition?.value && repetition.value !== "none" && (
                                <div className="mt-2">
                                    <label className="block text-xs font-medium text-gray-500 mb-1">
                                        Start Time
                                    </label>
                                    <Flatpickr
                                        options={{
                                            enableTime: true,
                                            noCalendar: true,
                                            dateFormat: "H:i", // ⏰ Only time, e.g. "08:30"
                                            time_24hr: true,
                                        }}
                                        value={startTime}
                                        onChange={(date, dateStr) => setStartTime(dateStr)} // 🔥 Save only "HH:mm"
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Select start time"
                                    />


                                </div>
                            )}
                        </div>
                        {/* Priority */}

                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Priority
                            </label>
                            <Select
                                options={priorityOptions}
                                value={priority}
                                onChange={setPriority}
                                placeholder="Select priority"
                            />
                        </div>

                        {/* Repetition */}


                        {/* Assign To */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Assign To
                            </label>
                            <Select
                                options={assignOptions}
                                value={assignTo}
                                onChange={setAssignTo}
                                placeholder="Select user"
                                getOptionValue={(option) => option.value}
                            />
                        </div>

                        {/* Add to List */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Add to List
                            </label>
                            <Select
                                options={leadOptions}
                                value={list}
                                onChange={setList}
                                placeholder="Select list"
                                getOptionLabel={(option) => (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <span
                                            style={{
                                                display: "inline-block",
                                                width: 12,
                                                height: 12,
                                                borderRadius: "50%",
                                                backgroundColor: option.color,
                                                marginRight: 8,
                                            }}
                                        />
                                        {option.label}
                                    </div>
                                )}
                                getOptionValue={(option) => option.value}
                            />
                        </div>
                    </div>

                    {/* Notes */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Notes
                        </label>
                        <textarea
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Enter notes"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            rows={3}
                        />
                    </div>

                    {/* Attachment */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Attachment
                        </label>
                        <input
                            type="file"
                            onChange={(e) => setFile(e.target.files[0])}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />

                        {
                            taskEdit.attachment &&
                            <img
                                className="task-modaleditattach"
                                src={`${url}/${taskEdit.attachment.replace(/\\/g, '/')}`}
                            />

                        }

                    </div>

                    {/* Actions */}
                    <div className="flex justify-end gap-3 mt-6">
                        <button
                            type="button"
                            onClick={() => setIsOpen(false)}
                            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition shadow-md"
                        >
                            Save Task
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TaskModalEdit;
